import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiinternationalairport() {



const cardData = {
  keyword: " Pune to Mumbai International Airport Cabs  ",

headingDescription:
  "Velocity Cab offers reliable and comfortable Pune to Mumbai International Airport cab services, ensuring a hassle‑free transfer to Chhatrapati Shivaji Maharaj International Airport (BOM) for all your travel needs. Whether you’re heading for a domestic flight or an international departure, our professional drivers, punctual pickups, and well‑maintained vehicles make your journey smooth and stress‑free. Choose from flexible booking options including one‑way rides, round trips, and customized plans with transparent pricing and no hidden charges. Our diverse fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking, real‑time flight tracking, and 24/7 customer support, Velocity Cab ensures you reach the Mumbai International Airport on time and in comfort.",

topPlaces: [
  {
    title: "Chhatrapati Shivaji Maharaj International Airport (Terminal 2)",
    description:
      "Chhatrapati Shivaji Maharaj International Airport’s Terminal 2 is Mumbai’s main international departure and arrival terminal, equipped with modern facilities, lounges, duty‑free shopping, and global connectivity. A Pune to Mumbai International Airport cab from Velocity Cab ensures a punctual and comfortable ride directly to this terminal for your flight."
  },
  
  {
    title: "Marine Drive",
    description:
      "Marine Drive, popularly known as the Queen’s Necklace, is a scenic coastal promenade stretching along the Arabian Sea. Visitors who land at the Mumbai International Airport can enjoy a relaxing cab drive to this picturesque location, perfect for evening walks and sunset views."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular beach destinations, famous for its lively atmosphere, street food stalls, and beautiful sunsets. After arriving via Pune to Mumbai International Airport cab, travelers often stop here for relaxing seaside views and local snacks."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "The Siddhivinayak Temple in Prabhadevi is a revered Hindu shrine dedicated to Lord Ganesha. Many travelers visiting Mumbai choose to take a cab from the international airport to seek blessings, enjoy the spiritual ambience, and admire the temple’s architecture."
  },
 
  {
    title: "Gateway of India",
    description:
      "The Gateway of India stands as one of Mumbai’s most iconic monuments along the Arabian Sea. Arriving travelers often take a cab from the international airport to visit this historic archway, enjoy sea views, and embark on ferry rides to Elephanta Island. A reliable cab service makes reaching this destination smooth and convenient."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a serene spiritual site located on an islet off the coast of Mumbai, connected to the city by a narrow walkway. Travelers arriving at the international airport may choose to visit this iconic mosque and tomb for quiet reflection and sea views."
  },
  {
    title: "Elephanta Caves",
    description:
      "The Elephanta Caves are ancient UNESCO World Heritage rock‑cut temples on Elephanta Island. Travelers who land at the Mumbai International Airport can take a cab to the Gateway of India and then a ferry to this culturally rich site known for its intricate sculptures."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is an expansive urban forest reserve offering nature trails, wildlife, and the historic Kanheri Caves. After arriving via a Pune to Mumbai International Airport cab, visitors often enjoy a peaceful escape into greenery and outdoor activities."
  },
   {
    title: "Bandra Worli Sea Link",
    description:
      "The Bandra Worli Sea Link is a striking cable‑stayed bridge offering dramatic views of the Arabian Sea and the Mumbai skyline. Visitors flying into Mumbai often take a scenic cab ride across this landmark to experience its architectural beauty and cityscape views."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a lively shopping street in South Mumbai filled with markets, boutiques, cafes, and local eateries. Travelers arriving at the international airport can take a cab to this vibrant area to shop, dine, and explore local culture."
  }
],



services: [
{
name: "Pune to Mumbai Airport",
description: "Pune to Mumbai Airport cab service offers comfortable and reliable transportation for passengers traveling from Pune to Mumbai Airport. Professional drivers ensure safe highway travel through the Mumbai–Pune Expressway with punctual pickup services. Vehicles are well maintained and provide comfortable seating with luggage space for travelers. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Ideal for domestic and international travelers. Flexible booking options allow passengers to reserve airport rides according to their flight schedules."
},
{
name: "Pune to Chhatrapati Shivaji International Airport Cab",
description: "Pune to Chhatrapati Shivaji International Airport cab service provides dependable transportation for passengers traveling to Mumbai’s main international airport. Comfortable vehicles with professional drivers ensure safe and timely journeys across the expressway. Pickup services are available from homes, hotels, offices, and railway stations across Pune. Ideal for international travelers and business passengers carrying luggage. Air-conditioned vehicles ensure smooth long-distance travel. Flexible booking options allow advance reservations for airport transfers."
},
{
name: "Pune to Mumbai Domestic Airport Cab",
description: "Pune to Mumbai domestic airport cab service offers convenient transportation for travelers heading to Mumbai’s domestic flight terminals. Vehicles are well maintained and suitable for highway travel with professional drivers ensuring punctual pickups. Pickup services are available from homes, offices, hotels, and railway stations in Pune. Ideal for business trips, family travel, and domestic flight departures. Comfortable interiors ensure relaxed journeys. Flexible booking options allow easy airport cab reservations."
},
{
name: "Pune to Chhatrapati Shivaji International Airport",
description: "Pune to Chhatrapati Shivaji International Airport travel service provides comfortable intercity transportation for passengers flying from Mumbai’s international airport. Vehicles offer spacious seating and luggage capacity suitable for airport transfers. Professional drivers ensure safe and timely journeys via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Flexible booking options allow travelers to plan airport transfers according to their flight schedules."
},
{
name: "Pune to Mumbai International Airport Innova Crysta Taxi",
description: "Pune to Mumbai International Airport Innova Crysta taxi service offers premium SUV transportation for comfortable airport transfers. Innova Crysta vehicles provide spacious seating and smooth ride quality ideal for long-distance highway travel. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Ideal for corporate travelers and families. Flexible booking options allow convenient luxury airport ride reservations."
},
{
name: "Pune to Mumbai International Airport Drop",
description: "Pune to Mumbai International Airport drop service provides reliable one-way transportation for travelers heading to Mumbai’s international airport terminals. Vehicles are comfortable and suitable for long-distance expressway journeys with luggage space for passengers. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Flexible booking options allow quick airport ride reservations."
},
{
name: "Pune to Mumbai International Airport One Way Cab",
description: "Pune to Mumbai International Airport one way cab service offers convenient transportation for passengers who need single-trip airport transfers. Vehicles are well maintained and suitable for highway travel with experienced drivers ensuring safe journeys. Pickup services are available from homes, hotels, offices, and railway stations across Pune. Ideal for business travelers and international passengers. Flexible booking options allow easy one-way airport cab reservations."
},
{
name: "Pune to Mumbai International Airport Ertiga Cab",
description: "Pune to Mumbai International Airport Ertiga cab service offers spacious SUV transportation for passengers traveling with family or luggage. The Ertiga vehicle provides comfortable seating and luggage space suitable for airport journeys. Professional drivers ensure safe driving and punctual pickup services via the Mumbai–Pune Expressway. Pickup services are available from homes, offices, hotels, and railway stations in Pune. Flexible booking options allow convenient airport ride scheduling."
},
{
name: "Pune to Mumbai Ertiga Cab",
description: "Pune to Mumbai Ertiga cab service provides comfortable SUV transportation for travelers traveling between Pune and Mumbai. The Ertiga vehicle offers spacious seating and luggage space suitable for family travel and airport transfers. Professional drivers ensure safe driving and punctual pickup services across the expressway. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Flexible booking options allow convenient cab reservations."
},
{
name: "Pune to Mumbai Innova Cab",
description: "Pune to Mumbai Innova cab service offers premium SUV transportation for passengers seeking comfortable long-distance travel. Innova vehicles provide spacious seating and smooth ride quality ideal for expressway journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for corporate travel and family trips. Flexible booking options allow easy ride reservations."
},
{
name: "Pune to Chhatrapati Shivaji International Airport Taxi",
description: "Pune to Chhatrapati Shivaji International Airport taxi service offers dependable airport transportation with experienced drivers and comfortable vehicles. Passengers can easily travel from Pune to Mumbai Airport with safe and timely journeys via the expressway. Pickup services are available from homes, offices, hotels, and railway stations. Ideal for international travelers and corporate passengers. Flexible booking options allow convenient airport taxi reservations."
},
{
name: "Pune to Mumbai International Airport Velocity Cabs",
description: "Pune to Mumbai International Airport Velocity cabs service offers fast and reliable airport transportation for travelers heading to Mumbai Airport. Vehicles are well maintained and suitable for expressway travel with professional drivers ensuring safe journeys. Pickup services are available from homes, offices, hotels, and railway stations in Pune. Ideal for business travelers, tourists, and families. Flexible booking options allow convenient airport ride planning."
},
{
name: "Pune to Mumbai International Airport Ertiga Cabs",
description: "Pune to Mumbai International Airport Ertiga cabs provide spacious SUV transportation for comfortable airport travel. Ertiga vehicles offer ample seating and luggage space suitable for passengers traveling with baggage. Professional drivers ensure punctual pickup and safe highway journeys. Pickup services are available from homes, offices, hotels, and railway stations in Pune. Flexible booking options allow easy airport ride reservations."
},
{
name: "Pune to Mumbai International Airport Sedan Cabs",
description: "Pune to Mumbai International Airport sedan cab service provides comfortable and economical transportation for airport transfers. Sedan vehicles offer smooth highway travel suitable for business travelers and small families. Professional drivers ensure punctual pickup and safe driving services. Pickup services are available from homes, hotels, offices, and railway stations across Pune. Flexible booking options allow passengers to reserve rides easily."
},
{
name: "Pune to Mumbai International Airport Swift Dzire Car",
description: "Pune to Mumbai International Airport Swift Dzire car service offers affordable sedan transportation for passengers traveling to Mumbai Airport. The Swift Dzire provides comfortable seating and smooth ride quality suitable for expressway journeys. Professional drivers ensure safe driving and punctual pickup services. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Flexible booking options allow cost-effective airport travel planning."
}
],

tableData: [
["Pune to Mumbai Airport","Pune to Chhatrapati Shivaji International Airport Cab"],
["Pune to Mumbai Domestic Airport Cab","Pune to Chhatrapati Shivaji International Airport"],
["Pune to Mumbai International Airport Innova Crysta Taxi","Pune to Mumbai International Airport Drop"],
["Pune to Mumbai International Airport One Way Cab","Pune to Mumbai International Airport Ertiga Cab"],
["Pune to Mumbai Ertiga Cab","Pune to Mumbai Innova Cab"],
["Pune to Chhatrapati Shivaji International Airport Taxi","Pune to Mumbai International Airport Velocity Cabs"],
["Pune to Mumbai International Airport Ertiga Cabs","Pune to Mumbai International Airport Sedan Cabs"],
["Pune to Mumbai International Airport Swift Dzire Car","Pune to Mumbai International Airport One Way Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Airport Transfer Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly operate on the Pune to Mumbai International Airport route via the Mumbai Pune Expressway. Our drivers are familiar with airport terminals, traffic patterns, and the best travel timings to ensure timely airport drops."
  },
  {
    WhyChooseheading: "Transparent Airport Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers clear and transparent pricing for Pune to Mumbai International Airport cab bookings. Customers receive full details about fare, toll charges, and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Airport Cab Availability",
    WhyChoosedescription: "Our Pune to Mumbai International Airport cab service is available 24 hours a day. Whether you have a late night international flight or an early morning departure, Velocity Cabs ensures reliable airport transportation."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are air-conditioned, well maintained, and regularly cleaned to provide a smooth and comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible Airport Travel Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way airport drop, airport pickup from Mumbai International Airport, and round-trip travel between Pune and Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for families, business travelers, and group airport transfers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide convenient pickup from homes, offices, hotels, and railway stations across Pune including Baner, Wakad, Hinjewadi, Hadapsar, Kharadi, Viman Nagar, and Pimpri Chinchwad."
  },
  {
    WhyChooseheading: "Reliable International Airport Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by travelers for Pune to Mumbai International Airport cab bookings thanks to punctual drivers, comfortable vehicles, and professional airport transfer service."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Pune to Mumbai International Airport?", answer: "Yes, Velocity Cabs provides reliable airport drop services from Pune to Mumbai International Airport with professional drivers and comfortable vehicles." },
  { question: "Is Pune to Mumbai International Airport cab service available 24 hours?", answer: "Yes, our airport cab service operates 24/7 to match international and domestic flight schedules." },
  { question: "Which vehicles are available for airport transfers?", answer: "Velocity Cabs provides sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers for group airport travel." },
  { question: "Can I book a one-way airport drop?", answer: "Yes, we provide one-way cab services from Pune to Mumbai International Airport." },
  { question: "Do you provide pickup from Pune homes or hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, offices, hotels, and railway stations across Pune." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Pune to Mumbai International Airport cab services online or via phone booking." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially for international flights and peak travel hours." },
  { question: "Do you provide airport pickup from Mumbai International Airport to Pune?", answer: "Yes, Velocity Cabs provides pickup service from Mumbai International Airport to Pune as well." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "A very punctual and comfortable Pune to Mumbai International Airport transfer. The cab was clean, and the ride felt smooth and well-coordinated for an on-time arrival.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "The Pune to Mumbai International Airport drop service was highly reliable. The vehicle was well-maintained, the driver was professional, and the journey felt completely stress-free.",
    rating: 5
  }
];











































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai International Airport Cab Service | Velocity Cabs",
  "description": "Velocity Cabs offers reliable Pune to Mumbai International Airport cab service with affordable fares and professional drivers. Book one-way or round-trip cabs to Chhatrapati Shivaji International Airport with premium options like Ertiga, Innova, and Innova Crysta. Enjoy safe, comfortable, and punctual airport transfers from Pune to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      

<Helmet>
  <title>Pune to Mumbai International Airport Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Mumbai International Airport cab with Velocity Cabs. Taxi service to Chhatrapati Shivaji International Airport with Innova, Ertiga & Crysta cabs. Safe, affordable & reliable airport transfer service." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/3.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiinternationalairport;